module.exports = __webpack_public_path__ + "img/CV.Utilities.Power.4_Way_HV_Duct.adc5b43e.png";